import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../store";

export default function AdminLogin() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "admin@sharkxelectric.com", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch {
      setErr("Credenciais inválidas");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen bg-slate-50 grid place-items-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-md p-10 shadow-sm">
        <div className="overline mb-3 text-center">Painel Admin</div>
        <h1 className="font-serif-display text-5xl text-center text-slate-900">Entrar</h1>
        <form onSubmit={submit} className="mt-10 space-y-4">
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="w-full bg-white border border-slate-300 px-5 py-4 rounded-md focus:border-sky-500 focus:outline-none" data-testid="admin-email" />
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Senha" className="w-full bg-white border border-slate-300 px-5 py-4 rounded-md focus:border-sky-500 focus:outline-none" data-testid="admin-password" />
          <button disabled={loading} className="btn-primary w-full !justify-center !py-4" data-testid="admin-login-btn">{loading ? "..." : "Entrar"}</button>
          {err && <div className="text-red-500 text-sm font-ui" data-testid="admin-error">{err}</div>}
        </form>
      </div>
    </main>
  );
}
